import { render, staticRenderFns } from "./offer-info-pane.vue?vue&type=template&id=2655ba87"
import script from "./offer-info-pane.vue?vue&type=script&lang=js"
export * from "./offer-info-pane.vue?vue&type=script&lang=js"
import style0 from "./offer-info-pane.vue?vue&type=style&index=0&id=2655ba87&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2655ba87')) {
      api.createRecord('2655ba87', component.options)
    } else {
      api.reload('2655ba87', component.options)
    }
    module.hot.accept("./offer-info-pane.vue?vue&type=template&id=2655ba87", function () {
      api.rerender('2655ba87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/offer-info-pane.vue"
export default component.exports